var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input__emoji",on:{"mouseover":_vm.swapEmoji}},[_vm._v(" "+_vm._s(_vm.currentEmoji)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }